module.exports = __webpack_public_path__ + "img/default_doctor.0a93842c.png";